module.exports = [{"name":"plus-9269-prime_freeze","version":2},{"name":"fan_plus_9520","version":2},{"name":"fan_plus_10024","version":2}]